import axios from "@/api/axiosAuthRequired.js"
import axiosAuthRequired from "./axiosAuthRequired"
import Vue from "vue"
import { getAuthHeaders } from "./auth"
import { BASE_URL } from "@/constants/util"

const baseUrl = `${process.env.PROGUIDES_WEB_URL}api/v2/`

export const getProductData = async productId => {
  try {
    const url = `${process.env.PROGUIDES_WEB_URL}api/v2/store/products/${productId}`
    const res = await axios.get(url)
    return res.data
  } catch (error) {
    console.error(error)
    return {}
  }
}

export const getProductPerks = async productId => {
  try {
    const url = `${process.env.PROGUIDES_WEB_URL}api/v2/store/products/${productId}/perks`
    const res = await axios.get(url)
    return res.data
  } catch (error) {
    console.error(error)
    return {}
  }
}

export const getStoreProducts = async () => {
  try {
    const url = `${process.env.PROGUIDES_WEB_URL}api/v2/store/products/points`
    const res = await axios.get(url)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

// Handles pg point packages as well as exact refills
export const checkoutWithPaypal = async (
  product,
  redirectUrl,
  queryString,
  promoCodes,
  giftProductAssetVariationId,
  senderName,
  recipientName,
  recipientEmail,
  message,
  orderType
) => {
  throw new Error("This item is no longer available.")
  try {
    let url = `${process.env.PROGUIDES_WEB_URL}payment/nonrecurring/get-paypal-auth-url?product_ids=${product.id}`
    if (redirectUrl) {
      url += `&redirect_url=${redirectUrl}`
    }
    if (queryString) {
      url += `&query_string=${queryString}`
    }
    if (promoCodes) {
      promoCodes.forEach((promoCode, index) => {
        url += `&promo_codes[${index}]=${promoCode}`
      })
    }
    if (giftProductAssetVariationId) {
      url += `&gift_product_asset_variation_id=${giftProductAssetVariationId}`
    }
    if (senderName) {
      url += `&sender_name=${senderName}`
    }
    if (recipientName) {
      url += `&recipient_name=${recipientName}`
    }
    if (recipientEmail) {
      url += `&recipient_email=${recipientEmail}`
    }
    if (message) {
      url += `&message=${message}`
    }
    if (orderType) {
      url += `&order_type=${orderType}`
    }

    // required for exact refill payments
    if (product.id === "exact-refill-product") {
      url += `&amount=${product.amount}`
    }

    const res = await axios.get(url)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const subscribeWithPaypal = async (body, queryString) => {
  try {
    let url = `${process.env.PROGUIDES_WEB_URL}payment/recurring/get-paypal-auth-url`
    const params = {
      query_string: queryString,
    }
    const config = {
      params,
    }
    const res = await axios.post(url, body, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response.data
  }
}

export const checkoutWithStripe = async body => {
  throw new Error("This item is no longer available.")
  try {
    const url = `${process.env.PROGUIDES_WEB_URL}payment/nonrecurring/stripe-callback`
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
    const res = await axios.post(url, body, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const subscribeWithStripe = async body => {
  try {
    const url = `${process.env.PROGUIDES_WEB_URL}payment/stripe/createMembership.php`
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
    const res = await axios.post(url, body, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getAppliedPromoCodes = async () => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const url = `${process.env.PROGUIDES_WEB_URL}api/v2/promo-codes/applied`
    const config = {
      headers: {
        Authorization: "Bearer " + clientCredentials,
      },
    }
    const res = await axiosAuthRequired.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const applyPromoCode = async code => {
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const url = `${process.env.PROGUIDES_WEB_URL}api/v2/promo-codes/redeem`
    const body = { code }
    const config = {
      headers: {
        Authorization: "Bearer " + clientCredentials,
      },
    }
    const res = await axiosAuthRequired.post(url, body, config)
    this.trackAnalyticsEvent("Promo code applied")
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getAvailableGiftOptions = async () => {
  try {
    const url = `${baseUrl}store/gifts`
    const res = await axios.get(url)
    return res.data
  } catch (error) {
    console.error(error)
    return []
  }
}

export const redeemGift = async code => {
  try {
    const url = `${baseUrl}store/gifts/redeem`
    const body = {
      code,
    }
    const clientCredentials = localStorage.getItem("client_credentials")
    const config = {
      headers: {
        Authorization: "Bearer " + clientCredentials,
      },
    }
    const res = await axios.post(url, body, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response.data
  }
}

export const getGiftOrderById = async orderId => {
  try {
    const url = `${baseUrl}user/account/orders/${orderId}`
    const clientCredentials = localStorage.getItem("client_credentials")
    const config = {
      headers: {
        Authorization: "Bearer " + clientCredentials,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getSubscriptionOptions = async () => {
  try {
    const url = `${baseUrl}store/products/subscriptions`
    const clientCredentials = localStorage.getItem("client_credentials")
    const config = {
      headers: {
        Authorization: "Bearer " + clientCredentials,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const fetchCourseProduct = async shortcode => {
  try {
    const url = `${BASE_URL}store/products/courses/${shortcode}`
    const config = {
      headers: getAuthHeaders(),
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

/**
 * Builds and makes a call to the Stripe exact refill endpoint.
 * @param { number } refillPriceInCents Amount to refill
 * @param { string } recaptchaToken Required Recaptcha token
 * @param { string } [paymentMethodId] Identifier for a saved card
 * @param { string } [cvcToken] Required for saved card payments
 * @param { string[] } [promoCodes] Array of applied promo codes
 */

export const checkoutWithStripeExactRefill = async ({
  refillPriceInCents,
  recaptchaToken,
  paymentMethodId,
  cvcToken,
  promoCodes,
}) => {
  throw new Error("This item is no longer available.")
  try {
    const clientCredentials = localStorage.getItem("client_credentials")
    const config = {
      headers: {
        Authorization: "Bearer " + clientCredentials,
      },
    }

    const paymentUrl = `${BASE_URL}payments/gateways/stripe/payment-intent/credit-refill`

    let paymentBody = {
      amount: refillPriceInCents,
      g_recaptcha_response: recaptchaToken,
    }

    if (promoCodes) {
      paymentBody.promo_codes = promoCodes
    }

    if (paymentMethodId) {
      paymentBody.payment_method_id = paymentMethodId
    }

    if (cvcToken) {
      paymentBody.cvc_token = cvcToken?.token?.id
    }

    const res = await axios.post(paymentUrl, paymentBody, config)
    return res.data
  } catch (error) {
    console.error(error)
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/api/store.js